.<template>
  <div>
    <div class="row justify-content-center mb-2">
      <button class="btn btn-add" id="v-step-0" @click="startTour">
        Iniciar Tour
      </button>
    </div>
    <div class="row justify-content-center" id="v-step-1"></div>
    <v-tour name="myTour" :steps="steps">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step1, index) of tour.steps"
            :key="index"
            :step="step1"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :skip="tour.skip"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template>
              <div slot="actions">
                <button
                  v-if="tour.currentStep != 0"
                  @click="tour.previousStep"
                  class="btn-step-back"
                >
                  Anterior
                </button>
                <button
                  @click="cancelTour(tour.currentStep)"
                  class="btn-step-back"
                >
                  Pular tour
                </button>
                <button
                  @click="
                    nextTour(
                      tour.currentStep,
                      tour.steps[index + 1],
                      tour.steps[index]
                    )
                  "
                  v-if="tour.currentStep != 1"
                  class="btn-step"
                >
                  Próximo
                </button>
                <button
                  @click="cancelTour(tour.currentStep)"
                  v-else
                  class="btn-step"
                >
                  Finalizar
                </button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
    <base-crud
      crudName="Estações de Trabalho"
      newText="Nova Estação de Trabalho"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="true"
      :dataForm="dataForm"
      :extra="extra"
      @configuration="configuration"
    />
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
export default {
  data: function () {
    return {
      extra: [
        {
          id: 1,
          label: "",
          class: "btn btn-crud edit",
          icon: "fas fa-cog",
          title: "Configuração",
          name: "configuration",
        },
      ],
      steps: [
        {
          target: "#v-step-0", // We're using document.querySelector() under the hood
          header: {
            title: "Tela de Reservas de Estação de Trabalho!",
          },
          params: {
            enableScrolling: false,
          },
          content: `Clique em <strong>próximo</strong> para continuar no tour. Caso não queira esse acompanhamento, clique em <strong>Pular tour</strong>. Se preferir poderá ver esse tour guiado a qualquer momento no botão destacado no menu superior.`,
        },
        {
          target: "#v-step-1",
          params: {
            enableScrolling: false,
          },
          content:
            "Na tela principal de Estação de Trabalho temos os Filtros de: ID, Título, Tag, Data Início, Empresa, Filial, Andar, Nº da Sala e Qtd de Pessoas. Em ações temos os botões <i class='fas fa-eye'></i> para consultar a Estação de Trabalho, <i class='fas fa-pencil-alt'></i> para editar, <i class='fas fa-trash-alt'></i> para deletar e <i class='fas fa-cog'></i> para adicionar/configurar posições na estação de trabalho. Para iniciar o tour de como criar uma nova Estação de Trabalho, clique em Nova Estação de Trabalho.",
        },
      ],
      table: "workstations",
      columns: [
        "id",
        "photo",
        "qrcodeid",
        "title",
        "tag",
        "company_id",
        "floor",
        "capacity",
        "actions",
      ],
      tableData: [
        "id",
        "photo",
        "qrcodeid",
        "title",
        "tag",
        "company_id",
        "floor",
        "number_room",
        "capacity",
      ],
      options: {
        filterable: ["id", "title", "tag", "floor", "company_id", "capacity"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        filterByColumn: true,
        debounce: 1000,
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          photo: "Foto",
          qrcodeid: "QRCode",
          title: "Titulo",
          tag: "Tag",
          company_id: "Empresa",
          floor: "Andar",
          capacity: "Qtd de Posições",
          actions: "Ações",
        },
        templates: {
          company_id: function (h, row, index) {
            return row.company ? row.company.company_name : "Sem Nome";
          },
          qrcodeid: function (h, row, index) {
            return "workstation-" + row.qrcodeid;
          },
        },
        requestFunction: function (data) {
          let requestData = {};
          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["company"];
          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "workstations/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    cancelTour(step) {
      const self = this;
      self.$tours["myTour"].skip();
      self.$store.commit("skipTour");

      let data = { finished_step: step };

      const api = self.$store.state.api + "user/finish-tour";

      self.$http.post(api, data).then((response) => {});
    },
    nextTour(step, actual_target, previous_target) {
      const self = this;

      if (step >= 31) {
        if (step >= 31) {
          $(previous_target.target).toggleClass("activeMenu");
        }
        $(actual_target.target).toggleClass("activeMenu");
      }

      if (step == 31) {
        $("#sidebar").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#pagCads").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#sidebar").toggleClass("active");
        $("html, body").animate({ scrollTop: 0 }, 0);
        self.$tours["myTour"].nextStep();
      } else {
        self.$tours["myTour"].nextStep();
      }
    },
    startTour() {
      let self = this;
      self.$tours["myTour"].start();
    },
    configuration(data) {
      this.$router.push({ path: "/workstations/configuration/" + data.row.id });
    },
    query: function (query) {
      let columns = {
        id: "id",
        photo: "photo",
        title: "title",
        tag: "tag",
        company_id: "company[company_name]",
        floor: "floor",
        number_room: "number_room",
        capacity: "capacity",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Workstations/Crud.vue